class More {
  constructor() {
    this.moreContainers = document.querySelectorAll('.js-more');
    this.maxHeight = 0;
    this.openClassName = 'is-open';
    this.init();
  }

  init() {
    if (!this.moreContainers) return;
    this.moreContainers.forEach((moreContainer) => {
      this.initSetMaxHeight(moreContainer);
      this.initOpen(moreContainer);
      const moreTrigger = moreContainer.querySelector('.js-more-trigger');

      moreTrigger.addEventListener('click', (e) => {
        const self = e.target;
        this.clickEvent(self);
      });
    });
  }

  clickEvent(self) {
    const targetContent = self.closest('.js-more');
    const moreContent = targetContent.querySelector('.js-more-content');
    const isOpen = moreContent.classList.contains('is-open');

    if (isOpen) {
      this.getMaxHeight(targetContent);
      this.moreClose(moreContent, self);
    } else {
      this.moreOpen(moreContent, self);
    }

    this.getButtonText(self);
  }

  initSetMaxHeight(moreContainer) {
    // .js-moreのdata-heightの値のmax-heightを設定
    const initHeight = moreContainer.dataset.height;
    const moreContent = moreContainer.querySelector('.js-more-content');
    moreContent.style.maxHeight = `${initHeight}px`;
  }

  initOpen(moreContainer) {
    // 初期表示がオープンの際の処理
    const moreContent = moreContainer.querySelector('.js-more-content');
    const isInitOpen = moreContent.classList.contains(this.openClassName);
    if (!isInitOpen) return;
    const moreTrigger = moreContainer.querySelector('.js-more-trigger');
    this.moreOpen(moreContent, moreTrigger);
  }

  getButtonText(moreTrigger) {
    // clickごとにボタンのdata-toggle-textの値を切り替える
    const initText = moreTrigger.textContent;
    const toggleText = moreTrigger.dataset.toggleText;
    moreTrigger.dataset.toggleText = initText;
    moreTrigger.textContent = toggleText;
  }

  getMaxHeight(targetContent) {
    const initHeight = targetContent.dataset.height;
    this.maxHeight = initHeight;
  }

  moreOpen(moreContent, moreTrigger) {
    moreContent.style.maxHeight = `${moreContent.scrollHeight}px`;
    moreContent.classList.add(this.openClassName);
    moreTrigger.classList.add(this.openClassName);
  }

  moreClose(moreContent, moreTrigger) {
    moreContent.style.maxHeight = `${this.maxHeight}px`;
    moreContent.classList.remove(this.openClassName);
    moreTrigger.classList.remove(this.openClassName);
  }
}

export default More;
